import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { routing } from './app.routes';
import { AuthGuard, AuthenticationService, TokensService } from './services/index';
import { OrdersComponent, OrderDetailComponent } from './orders/index';
import { AlertComponent, AlertService } from './alert/index';
import { HeaderComponent, FooterComponent } from './layout/index';
import { HomeComponent } from './home/home.component';
import { FeeComponent } from './fee/fee.component';
import { FeesComponent } from './fees/fees.component';
import { InventoryComponent } from './inventory/inventory.component';
import { PackagingComponent, PackagingItemComponent } from './packaging';
import { LoaderComponent } from './shared/loader/loader.component';
import { ArticleDetailComponent } from './inventory/article-detail/article-detail.component';
import { ShelvesComponent } from './shared/shelves/shelves.component';
import { StoragePlaceComponent } from './storage-place/storage-place.component';
import { PasswordChangeComponent } from './password-change/password-change.component';
import { ArticleItemComponent } from './orders/article-item/article-item.component';
import { PackagingDetailComponent } from './orders/packaging-detail/packaging-detail.component';
import { TrackingDetailComponent } from './orders/tracking-detail/tracking-detail.component';
import { EventsComponent } from './orders/events/events.component';
import { PositionDetailComponent } from './orders/position-detail/position-detail.component';
import { ContainerComponent } from './storage-place';
import { ClientInventoryComponent } from './client-inventory/client-inventory.component';

@NgModule({
  declarations: [
    AppComponent,
    AlertComponent,
    LoginComponent,
    AlertComponent,
    HeaderComponent, FooterComponent,
    HomeComponent,
    OrdersComponent, OrderDetailComponent, FeeComponent, FeesComponent, InventoryComponent, PackagingComponent, PackagingItemComponent,
    LoaderComponent, ArticleDetailComponent, ShelvesComponent, ShelvesComponent, StoragePlaceComponent, ContainerComponent, ClientInventoryComponent,
    PasswordChangeComponent, ArticleItemComponent, PackagingDetailComponent, TrackingDetailComponent, EventsComponent, PositionDetailComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    routing
  ],
  providers: [
      AlertService,
      AuthenticationService,
      AuthGuard      
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/app.module.ts